<script lang="ts">
	import { Card, ProductComposite } from "@hitit/new_ui";
	import { t } from "@hitit/hub/src/stores";
	import { formatKrwNumber, getKeyInTranslation } from "../../../utils";
	import type OptionItem from "../../../class/StoreItem/OptionItem";

	export let item: OptionItem;

</script>

<div class="container">
	<Card noPadding>
		<div class="wrapper">
			<ProductComposite
				name={$t('global.product.option_name')}
				value={getKeyInTranslation(item.getTranslation(), 'name', 'ko') || ''} />
			<ProductComposite
				name={$t('global.product.option_price')}
				value={formatKrwNumber(item.getPrice())} />
			<ProductComposite
				name={$t('global.product.stock')}
				value={item.getStockAvailable() ? String(item.getStock()) : '-'} />
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../../variables.scss";

	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
	}

	.wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 20px 10px;
		gap: 20px;
	}

	@include DesktopSize {
		.wrapper {
			padding: 30px;
		}
	}

</style>
